import { useState, useEffect } from "react";
import { getSiteApplicationDetail } from "services/clients/sites/siteApplications/siteApplicationDetails";

/**
 * Resolves showAssetReferences from the SiteApp endpoint,
 * falling back to siteDetails for Client Admin mode.
 */
const useShowAssetReferences = (siteDetails) => {
	const [showAssetReferences, setShowAssetReferences] = useState(false);

	useEffect(() => {
		const me = JSON.parse(sessionStorage.getItem("me")) || JSON.parse(localStorage.getItem("me"));
		const siteAppID = me?.siteAppID;

		if (!siteAppID) {
			setShowAssetReferences(siteDetails?.showAssetReferences ?? false);
			return;
		}

		const fetchConfig = async () => {
			try {
				const response = await getSiteApplicationDetail(siteAppID);
				if (response.status) {
					setShowAssetReferences(response.data?.showAssetReferences ?? false);
				}
			} catch {
				setShowAssetReferences(false);
			}
		};
		fetchConfig();
	}, [siteDetails]);

	return showAssetReferences;
};

export default useShowAssetReferences;
